<template>
  <div :class="classes" class="bordered-two-column">
    <div class="template">
      <div class="background"></div>
      <div class="border-box stagger-in"><div class="inner"></div></div>
      <div class="column content">
        <div class="template-content">
          <div class="counter-component stagger-in">
            {{indexValue + 1}} - {{countValue}}
          </div>
          <h1 class="stagger-in" v-html="header"></h1>
          <p class="stagger-in" v-html="main"></p>
          <div class="supp stagger-in"><img :src="suppAsset"/></div>
        </div>
      </div>
      <div class="column image stagger-in">
        <div class="image-column"><img :src="imageAsset"/></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { TimelineMax, Power2, Circ, Power4 } from 'gsap';
  import { gsapCustomEase } from '../util';

  export default {
    name: 'BorderedTwoColumn',
    props: {
      header: String,
      main: String,
      supp: String,
      image: String,
      classes: Array,
      index: Number,
      count: Number,
      indexValue: Number,
      countValue: Number,
      finishTransition: Function
    },
    created() {
      this.imageAsset = (this.image != '') ? require('../assets/images/' + this.image) : null
        this.suppAsset = (this.supp != '') ? require('../assets/images/' + this.supp) : null
    },
    methods: {
    	transitionIn: function (dir) {
        // console.log("TRANSITION FUNC BorderedTwoColumn");
        let $el = this.$el;
        let bg = $el.querySelector('.background');
        let staggerEl = $el.querySelectorAll('.stagger-in');
        let border = $el.querySelector('.border-box');
        let borderInner = border.querySelector('.inner');

        let tl = new TimelineMax({onComplete: this.transitionInComplete})

        tl
        .set(bg, {yPercent: dir*100})
        .set(staggerEl, {opacity: 0, y: dir*1200})
        .to(bg, 0.8, {yPercent: 0, ease: Power2.easeInOut}, 0)
        .staggerTo(staggerEl, 1.2, {opacity: 1, y: 0, ease: Power4.easeOut}, 0.04, 0.32)

        let slides = document.querySelectorAll('.slide');
        tl.set(slides, {clearProps: 'opacity'})
      },
      transitionOut: function () {
        let tl2 = new TimelineMax({onComplete: this.transitionOutComplete})

        tl2
        .set(this.$el, {opacity: 1})
      },
      transitionInComplete: function() {
        // console.log("ENABLE SITE INTERACTIONS")
        this.finishTransition();
      },
      transitionOutComplete: function() {
        // console.log("CLEAN UP SLIDE")
      }
    }
  } 
</script>

<style lang="scss">
@import '../sass/variables';

	.bordered-two-column{
    // transform-origin: 50% 0%;
    .background{
      background: #fff;
    }
    .template{
      height: 100%;
      position: relative;
      @include vw-units((
        'padding-top': 3
      ));
      @media #{$desktopQuery}{
        display: flex;
        justify-content: space-around;
        align-items: center;
      }
      @media #{$phoneQuery}{
        min-height: 177.77vw;
        height: auto;
      }
    }
    .border-box{
      @include vw-units((
        'width': 60.7,
        'height': 35.2
      ));
      // background: $blue;
      border: 30px solid $blue;
      position: absolute;
      z-index: 0;
      // .inner{
      //   position: absolute;
      //   width: calc(100% - 60px);
      //   height: calc(100% - 60px);
      //   background: #fff;
      //   top: 30px;
      //   left: 30px;
      // }
      @media #{$phoneQuery}{
        width: 70%;
        height: 72%;
        top: 10%;
        left: calc(50% - 10px);
        border: 20px solid $blue;
      }
    }
    .column{
      width: 50%;
      padding: 0 7%;
      z-index: 1;
      &.image{
        padding-left: 2%;
        padding-right: 12%;
      }
      @media #{$phoneQuery}{
        width: 100%;
        &.image{
          padding: 0;
          padding-bottom: 16vw;
          
        }
        &.content{
          padding-top: 20vw; 
          padding-bottom: 12vw;
        }
      }
    }	
    .template-content{
      h1{
        line-height: 1.1;
        @include vw-pixels((
          'font-size': 48,
          'margin-bottom': 8
        ), 1.5);
      }
      p{
        color: $grey;
        font-family: freight-text-pro, serif;
        letter-spacing: 0.01em;
        line-height: 1.3;
        @include vw-pixels((
          'margin-left': 32,
          'font-size': 22
        ), 2);
        @media #{$phoneQuery}{
          margin-left: 0;
          // font-size: 3.2vw;
        }
      }
      .supp{
        @include vw-units((
          'width': 18
        ));
        margin-left: 10%;
        margin-top: 4%;
        @media #{$phoneQuery}{
          margin-left: 0;
          width: 56vw;
        }
      }
    }
    img{
      display: block;
      width: 100%;
    }
    &.neighbor-5{
      .template-content{
        .supp{
          @include vw-units((
            'width': 32
          ));
        }
      }
    }
	}
</style>